import React, { Fragment, useEffect, useState, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { ReactComponent as Logo } from "assets/img/logo.svg";
import {
  Link,
  NavLink,
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import Toast from "components/toast/toast";
import { images } from "constants";
import authStore from "stores/authStore";

import { GET_PROMOTION_POST } from "GraphQL/Queries";
import { Button } from "react-scroll";
import { MdMenu } from "react-icons/md";
import { Close } from "@mui/icons-material";

import Drawer from "react-modern-drawer";

const LandingPageHeader = ({ shadowed }) => {
  const location = useLocation();

  const { setVerificationCode } = authStore;

  const navigate = useNavigate();
  const { referral_code, id } = useParams();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    if (token) {
      setVerificationCode(token);
    }
  }, [token]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 20);
    });
  }, []);

  // Query handling
  const skip = !referral_code;

  const { data: promo } = useQuery(GET_PROMOTION_POST, {
    variables: { couponCode: referral_code },
    skip,
  });

  const promoData = useMemo(() => {
    return promo?.getPromotionPost?.promotionPost;
  }, [promo?.getPromotionPost?.promotionPost]);

  const linkup = promoData
    ? `/auth/signup/referralCode/${referral_code}/promotion`
    : "/auth/signup";

  const [showMenu, setShowMenu] = useState(false);

  const navLinks = [
    {
      name: "Home",
      link: "/",
    },

    { name: "Gallery", link: "/gallery" },
    { name: "About", link: "/about" },
    { name: "Blog", link: "/contents" },
  ];

  return (
    <Fragment>
      <header
        style={{
          boxShadow: scroll ? "0px 4px 48px rgba(226, 226, 226, 0.1)" : "",
        }}
        className={` absolute w-full bg-transparent z-[1000] font-[Satoshi] py-5 px-4 lg:px-12 ${
          shadowed && "shadow-header drop-shadow-lg"
        }`}
      >
        <Toast />

        <nav className="flex items-center justify-between w-full">
          <div className="flex flex-1 items-center gap-x-8">
            <NavLink to={"/"}>
              <Logo className="w-24 sm:w-32" />
            </NavLink>

            <div className="hidden lg:flex items-center gap-x-7">
              {navLinks?.map((item) => (
                <NavLink to={item.link}>
                  <span
                    className={`${
                      location.pathname === item.link
                        ? "text-blue-100"
                        : "text-[#06202C]"
                    } hover:text-blue-100 transition-colors block text-sm font-medium  cursor-pointer `}
                  >
                    {item.name}
                  </span>
                </NavLink>
              ))}
            </div>
          </div>

          <div className="flex-1 hidden lg:flex justify-end  gap-x-6">
            <button
              onClick={() => {
                navigate("/auth/login");
              }}
              className="cursor-pointer rounded-lg gap-x-3 font-bold hover:bg-opacity-80 px-5 md:px-10  disabled:bg-opacity-50 focus:bg-opacity-80 bg-transparent border border-blue-100 text-blue-100 flex justify-center items-center"
            >
              <span>Login</span>
              <img alt="get started" src={images.logArrow} />
            </button>

            <button
              onClick={() => {
                navigate(linkup);
              }}
              className="cursor-pointer rounded-lg gap-3 font-bold hover:bg-opacity-80 py-3 px-5 md:px-10 text-white-100 disabled:bg-opacity-50 focus:bg-opacity-80 bg-blue-100 flex justify-center items-center"
            >
              <span>Get Started</span>
            </button>
          </div>

          <div className="lg:hidden flex justify-end w-full">
            <MdMenu onClick={() => setShowMenu(true)} size="32px" />
          </div>
          <Drawer
            open={showMenu}
            onClose={() => setShowMenu(false)}
            direction="right"
            style={{ width: "100%", padding: "20px", maxWidth: "250px" }}
            lockBackgroundScroll={true}
          >
            <Close onClick={() => setShowMenu(false)} />

            <div className="mt-9 flex flex-col text-[#093549] w-full font-medium gap-9 items-center">
              {navLinks?.map((item) => (
                <NavLink to={item.link}>
                  <span
                    className={`${
                      location.pathname === item.link
                        ? "text-blue-100"
                        : "text-[#06202C]"
                    } hover:text-blue-100 transition-colors block text-sm font-medium  cursor-pointer `}
                  >
                    {item.name}
                  </span>
                </NavLink>
              ))}
            </div>

            <div className="flex flex-col justify-center items-center mt-9  gap-6">
              <button
                onClick={() => {
                  navigate("/auth/login");
                }}
                className="cursor-pointer rounded-lg gap-x-3 font-bold hover:bg-opacity-80 py-3 px-5 md:px-10  focus:bg-opacity-80 bg-transparent border border-blue-100 text-blue-100 flex justify-center items-center"
              >
                <span>Login</span>
                <img alt="get started" src={images.logArrow} />
              </button>

              <button
                onClick={() => {
                  navigate(linkup);
                }}
                className="cursor-pointer rounded-lg gap-3 font-bold hover:bg-opacity-80 py-3 px-5 md:px-10 text-white-100 disabled:bg-opacity-50 focus:bg-opacity-80 bg-blue-100 flex justify-center items-center"
              >
                <span>Get Started</span>
              </button>
            </div>
          </Drawer>
        </nav>
      </header>
    </Fragment>
  );
};

export default LandingPageHeader;
